document.addEventListener("DOMContentLoaded", function () {
  const previewSection = document.querySelector(".preview-mode");
  const fullImagesSection = document.querySelector(".full-images");
  const aplusImagesSection = document.querySelector(".aplus-images");
  const wellnessSection = document.querySelector(".full-images-wellness");

  // Only set up toggle functionality if it's not a wellness product
  if (!wellnessSection && previewSection && fullImagesSection) {
    // Set up event listeners for both buttons
    document.querySelectorAll(".toggle-button").forEach((button) => {
      button.addEventListener("click", function () {
        const action = this.getAttribute("data-action");

        if (action === "see-all") {
          // Show all images
          previewSection.style.display = "none";
          fullImagesSection.style.display = "block";
        } else if (action === "see-less") {
          // Show only preview
          previewSection.style.display = "block";
          fullImagesSection.style.display = "none";

          // Scroll to the top of the section
          if (aplusImagesSection) {
            aplusImagesSection.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }
      });
    });
  }
});